import { Badge } from '@mantine/core';
import CloseIcon from '@/icons/close.svg';
import { PropsWithChildren, ReactNode } from 'react';

interface TagProps extends PropsWithChildren {
  iconClick?: () => void;
  badgeClick?: () => void;
  icon?: ReactNode;
}

export function AssetTagBadge({ iconClick, icon, children, badgeClick }: TagProps) {
  return (
    <Badge
      onClick={badgeClick}
      className={badgeClick ? 'cursor-pointer' : ''}
      p={12}
      variant='default'
      color='teal.6'
      c='dark.9'
      rightSection={
        icon ?? (
          <CloseIcon
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              iconClick && iconClick();
            }}
            className='cursor-pointer'
          />
        )
      }
    >
      {children}
    </Badge>
  );
}
